import { EIcons } from '../at-icon/icons';
import { IAtDropdownFieldProps } from './at-dropdown-field.types';

export const atDropdownFieldMockData: IAtDropdownFieldProps = {
  id: 'location',
  icon: EIcons.LOCATION,
  label: 'Build Location',
  options: [
    { label: 'IN, Indianapolis', value: 'Indianapolis' },
    { label: 'NC, Franklin', value: 'Franklin' },
    { label: 'OH, Cleveland', value: 'Cleveland' },
    { label: 'CA, San Diego', value: 'San Diego' },
    { label: 'TX, Dallas', value: 'Dallas' },
    { label: 'FL, Miami', value: 'Miami' },
    { label: 'NY, New York', value: 'New York' },
    { label: 'WA, Seattle', value: 'Seattle' },
    { label: 'CA, San Francisco', value: 'San Francisco' },
    { label: 'CA, Los Angeles', value: 'Los Angeles' },
    { label: 'CA, San Jose', value: 'San Jose' },
  ],
  required: true,
  value: '',
};
